import type { ZodType } from 'zod';
import { z } from 'zod';
import type {
  CprContactFilterRequest,
  CprContactGroupMember,
} from '#pie/internal/api/pie-bff';
import { createFiltersAtom } from './createFiltersAtom';
import { createSortingAtom } from './createSortingAtom';
import type { DefaultSorting } from './defaultSorting';

export const defaultCprOrganisationDetailFilters = {
  contactGroupIds: [],
  organisationIds: [],
} satisfies z.infer<typeof cprOrganisationDetailFiltersSchema>;

export const cprOrganisationDetailFiltersSchema: ZodType<
  CprContactFilterRequest,
  unknown
> = z
  .object({
    contactGroupIds: z.array(z.string()).optional(),
  })
  .catch(defaultCprOrganisationDetailFilters);

export const cprOrganisationDetailFiltersAtom =
  createFiltersAtom<CprContactFilterRequest>({
    defaultFilters: defaultCprOrganisationDetailFilters,
    filtersSchema: cprOrganisationDetailFiltersSchema,
  });

export const defaultCprOrganisationDetailSorting: DefaultSorting<CprContactGroupMember> =
  {
    desc: false,
    id: 'contactGroup.label',
  };

export const cprOrganisationDetailSortingAtom = createSortingAtom({
  defaultSorting: defaultCprOrganisationDetailSorting,
});
